// Legacy type imported directly for backward compatibility
import type { TextKeyframe } from '../../../types/experience';

/**
 * Parse duration string (e.g., "3:45" or "03:45") to seconds
 */
export function parseDurationToSeconds(duration: string): number {
  if (!duration) return 30;
  const parts = duration.split(':');
  if (parts.length === 2) {
    const minutes = parseInt(parts[0], 10) || 0;
    const seconds = parseInt(parts[1], 10) || 0;
    return minutes * 60 + seconds;
  }
  if (parts.length === 3) {
    const hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    const seconds = parseInt(parts[2], 10) || 0;
    return hours * 3600 + minutes * 60 + seconds;
  }
  return 30;
}

/**
 * Get text at playback position for preview (resolves keyframeIndex to time)
 */
export function getTextAtPosition(
  defaultText: string,
  textKeyframes: TextKeyframe[] | undefined,
  playbackPosition: number,
  previewTrackId: number | null,
  globalKeyframes: number[]
): string {
  if (!textKeyframes || textKeyframes.length === 0 || previewTrackId === null) {
    return defaultText;
  }
  const trackKeyframes = textKeyframes.filter(kf => kf.trackId === previewTrackId);
  if (trackKeyframes.length === 0) return defaultText;

  const resolved = trackKeyframes
    .map(kf => ({
      time: globalKeyframes[kf.keyframeIndex] ?? 0,
      text: kf.text,
    }))
    .sort((a, b) => a.time - b.time);

  let currentText = defaultText;
  for (const kf of resolved) {
    if (playbackPosition >= kf.time) {
      if (kf.text !== undefined) currentText = kf.text;
    } else {
      break;
    }
  }
  return currentText;
}
